/*!
 * appCues.js — cues an app adds to the language
 * © 2026 Rob Canning — GPLv3
 *
 * The score's own cues -- page(), nav(), pause(), stop(), play(), zoom(),
 * station() ... -- move its transport, pages and view. The score registers
 * them (scoreCues.js); the dispatcher and the project scan find them here.
 * A page without the score (Oscilla Live, live.js) has none of them.
 */

const handlers = new Map();

/** handler(ast, cueElement, { isRemote }) runs a cue of this type. */
export function registerAppCue(type, handler) { handlers.set(type, handler); }

/** The handler registered for a cue type, or null. */
export const appCue = type => handlers.get(type) ?? null;
